import { Components, Theme } from "@mui/material";
import { Colors, Shades } from "style/Colors";
import { BORDER_RADIUS } from "style/Constant";

export const MuiOutlinedInput: Components<Theme>["MuiOutlinedInput"] = {
  styleOverrides: {
    input: {
      paddingTop: "10px",
      paddingBottom: "10px",
    },
    notchedOutline: {
      borderColor: Colors.gray,
      borderRadius: BORDER_RADIUS,
      "& legend": {
        maxWidth: "0 !important",
      },
    },
    root: {
      backgroundColor: Colors.grayLight,
      borderRadius: BORDER_RADIUS,
      boxShadow: `0px 0px 3px ${Colors.gray}`,
      fontFamily: "arial",

      "& .--normal": {
        height: "60px !important",
      },

      "& .--small": {
        height: "40px !important",
      },

      "&.Mui-disabled": {
        color: Colors.gray,
        backgroundColor: Shades.gray10,
        opacity: 0.9,

        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: Colors.gray,
        },
      },

      "&.MuiAutocomplete-inputRoot": {
        padding: "5px 10px !important",
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: Colors.accentGreenLight,
        borderWidth: "1px",
      },

      "&.Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: `${Colors.red} !important`,
      },
    },
    multiline: {
      borderRadius: "0.5rem",
    },
  },
};
